var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-icon-wrapper"},[_c('div',{staticClass:"menu-icon",class:{ 'open': _vm.open },on:{"click":function($event){return _vm.$emit('update:open', !_vm.open)}}},[_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }